import styled from 'styled-components';

export const TitleDisciplina = styled.h1`
  color: white;
  margin-bottom: 1rem;
`;

export const Title = styled.h1`
  color: white;
`;

export const DescricaoQuestao = styled.p`
  font-size: 0.9rem;
  margin-top: 1rem;
  color: white;
`;

export const AlternativaCompleta = styled.div`
  margin-top: .5rem;
  outline: solid white .1rem;
  background-color: #024089;
  padding: 1rem;
  margin-top: 2rem;

  p {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    color: white;
  }
`;

export const Questoes = styled.div`

  .correct {
      background-color: green;
    }
`;

export const Proxima = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;

  a {
    height: 2.2rem;
    margin: 0rem;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2.2rem;
  }
`;
